import { IonAlert } from "@ionic/react";
import React from "react";

const RemoveAlert = (props: {
  isOpen: boolean;
  onCancel: Function;
  onDelete: Function;
}) => {
  return (
    <IonAlert
      isOpen={props.isOpen}
      onDidDismiss={() => props.onCancel()}
      cssClass="remove-alert"
      header={"Confirm"}
      message={"Are you sure you want to remove this item?"}
      buttons={[
        {
          text: "Cancel",
          role: "cancel",
          cssClass: "secondary",
          handler: () => {
            props.onCancel();
          },
        },
        {
          text: "Delete",
          cssClass: "danger",
          handler: () => {
            props.onDelete();
          },
        },
      ]}
    />
  );
};

export default RemoveAlert;
